import './app.css';

import meta from './data/meta.json';
import share from './data/share.json';
import WebFont from 'webfontloader';
import {analyticsEvent, attrEvents} from './js/analytics';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* fonts */
WebFont.load({
    custom: {
        families: ['Activist:n4', 'Formular:n4,n7'],
        urls: ['./css/fonts.css']
    }
    /*
    google: {
        families: ['Roboto:400,700:cyrillic']
    },*/
    /*
    typekit: {
        id: 'xxxxxx'
    }*/
});

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
/* <button data-event="click" data-event-category="Button" data-event-label="Play"> */
analyticsEvent();
attrEvents();

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    import(/* webpackPrefetch: true */ './js/sw').then(func => {
        func.default();
    });
}

/* lazy loading (https://github.com/verlok/lazyload) */
if (document.querySelector('.lazy') !== null) {
    import(/* webpackPrefetch: true */ './js/lazyloading').then(func => {
        func.default();
    });
}

/* share buttons */
// if (document.querySelector('.share') !== null) {
//     import(/* webpackPrefetch: true */ './js/share').then(func => {
//         func.default();
//     });
// }

let currentValue = 0;
let result = 0;
let currentQuestionIndex = 0;
let packshotShowing = false;
let removeDisabledBtn = false;

/* radio click */
const answers = document.querySelectorAll('.question__answer');
for (let i = 0; i < answers.length; i++) {
    answers[i].addEventListener('click', function(e) {
        const active = document.querySelector('.active');
        if (active) {
            active.classList.remove('active');
        }
        e.target.classList.add('active');
        currentValue = e.target.getAttribute('value');
        if (!removeDisabledBtn) {
            document.querySelector(`.question[data-index='${currentQuestionIndex + 1}'] .btn`).classList.remove('disabled');
            removeDisabledBtn = true;
        }
    });
}

/* start test */
document.querySelector('.intro__btn .btn').addEventListener('click', () => {
    document.querySelector('.intro').classList.remove('show');
    document.querySelector('.question[data-index="1"]').classList.add('show');
    document.querySelector('.header').scrollIntoView();
    document.querySelector('.content__emojis').classList.remove('hidden');
    animationEmojis();
});

/* next question */
const nextBtns = document.querySelectorAll('.question__btn .btn');
for (let i = 0; i < nextBtns.length; i++) {
    nextBtns[i].addEventListener('click', function() {
        const currentQuestion = document.querySelector(`.question[data-index='${currentQuestionIndex + 1}']`);
        const nextQuestion = document.querySelector(`.question[data-index='${currentQuestionIndex + 2}']`);
        currentQuestion.classList.remove('show');
        result += +currentValue;
        currentValue = 0;
        removeDisabledBtn = false;
        if (currentQuestionIndex === 3 && !packshotShowing) {
            document.querySelector('.header').scrollIntoView();
            document.querySelector('.packshot').classList.add('show');
            document.querySelector('.content__emojis').classList.add('hidden');
        } else if (currentQuestionIndex === 8) {
            const resultIndex = result < 9 ? 1 : result < 14 ? 2 : 3;
            document.querySelector(`.result__wrap[data-index='${resultIndex}']`).style.display = 'block';
            if (document.querySelector('.share') !== null) {
                import(/* webpackPrefetch: true */ './js/share').then(func => {
                    func.default(null, {
                        url: `${meta.url}/share.php?type=${resultIndex - 1}`,
                        title: share[resultIndex - 1].title,
                        description: share[resultIndex - 1].description,
                        image: `${meta.url}/img/share${share[resultIndex - 1].image}`
                    });
                });
            }
            // remove setTimeout
            document.querySelector('.content__emojis').classList.add('hidden');
            document.querySelector('.header').scrollIntoView();
            document.querySelector('.result').classList.add('show');
        } else {
            nextQuestion.classList.add('show');
            currentQuestionIndex++;
        }
    });
}

/* packshot nextBtn */
document.querySelector('.packshot__btn .btn').addEventListener('click', () => {
    document.querySelector('.packshot').classList.remove('show');
    packshotShowing = true;
    document.querySelector(`.question[data-index='${currentQuestionIndex + 2}']`).classList.add('show');
    document.querySelector('.content__emojis').classList.remove('hidden');
    currentQuestionIndex++;
});

/* floating emojis*/
const animationEmojis = function() {
    const $parent = document.querySelector('.content__emojis'),
        $elements = document.querySelectorAll('.content__emojis > .item'),
        vertSpeed = 30,
        horiSpeed = 5;

    const height = $parent.offsetHeight,
        width = $parent.offsetWidth;
    $parent.style.overflow = 'hidden';
    $parent.classList.remove('hidden');

    const items = [];
    for (let i = 0; i < $elements.length; i++) {
        const $element = $elements[i],
            elementWidth = $element.offsetWidth,
            elementHeight = $element.offsetHeight;

        $element.style.position = 'absolute';

        const item = {
            element: $element,
            elementHeight: elementHeight,
            elementWidth: elementWidth,
            ySpeed: -vertSpeed,

            omega: (2 * Math.PI * horiSpeed) / (width * 20),
            random: (Math.random() / 2 + 0.5) * i * 10000,
            x: function(time) {
                return ((Math.sin(this.omega * (time + this.random)) + 1) / 2) * (width - elementWidth);
            },
            y: height + Math.random() * 0.05 * i * elementHeight,
            scale: function() {
                return this.y / height < 0 ? 0 : this.y / height;
            },
            opacity: 0
        };
        items.push(item);
    }
    const countElements = items.length;
    let opacityFirstQuestion = 0;
    const animationStep = function() {
        const time = +new Date();
        if (items.length < countElements) {
            opacityFirstQuestion += 2 / countElements;
        }
        document.querySelector('.question[data-index="1"]').style.opacity = opacityFirstQuestion;

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const transformString = 'translate3d(' + item.x(time) + 'px,' + item.y + 'px,0px) scale(' + item.scale() + ')';
            item.element.style.transform = transformString;
            item.element.style.webkitTransform = transformString;
            if (item.y < -item.elementHeight) {
                items.splice(i, 1);
            }

            if (items.length === 0) {
                document.querySelector('.question[data-index="1"]').classList.add('start');
                $parent.style.display = 'none';
                return;
            }

            item.y += item.ySpeed;
        }
        requestAnimationFrame(animationStep);
    };
    requestAnimationFrame(animationStep);
};
